import {
  Box,
  Breadcrumbs,
  Card,
  Grid,
  keyframes,
  Stack,
  styled,
  Typography
} from '@mui/material';
import { drawerWidth } from '../../Navigation/styled';
import { fontSizes } from '../../../../layouts/fontSizes';

interface StyledAppBarProps {
  open: boolean;
}

const blink = keyframes`
  0% { opacity: 0.3; }
  50% { opacity: 1; }
  100% { opacity: 0.3; }
`;

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  animation: `${blink} 1.5s infinite`
}));

const BreadcrumbsContainer = styled(Breadcrumbs)({
  margin: '16px 0'
});

const StyledChildBreadcrumb = styled(Typography)({
  color: '#7A5AF8',
  fontSize: fontSizes.default
});

const StyledHomeBreadcrumb = styled(Typography)({
  color: 'inherit',
  fontSize: fontSizes.default,
  cursor: 'pointer',
  '&:hover': {
    color: '#7A5AF8'
  }
});

const StyledParentBreadcrumb = styled(Typography)({
  color: 'inherit',
  fontSize: fontSizes.default
});

const SkeletonGridContainer = styled(Grid)({
  height: 'calc(100vh - 100px)'
});

const DashboardContainer = styled(Box)<StyledAppBarProps>(({ open }) => ({
  flexGrow: 1,
  padding: '24px',
  transition: 'margin 0.3s',
  marginLeft: open ? `${drawerWidth}px` : '60px',
  backgroundColor: '#F4F6F8',
  height: '100vh',
  overflowY: 'auto'
}));

const RetoolEmbedContainer = styled(Box)({
  height: 'calc(100vh - 151px)',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto'
});

const FlexContainer = styled(Box)({
  display: 'flex',
  flex: 1
});

const DashboardFlexContainer = styled(Box)({
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center'
});

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 30,
  padding: theme.spacing(3),
  backgroundColor: '#fff',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
  }
}));

const IconBox = styled(Box)(({ theme }) => ({
  minWidth: 48,
  minHeight: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(2),
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
}));

const CardHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: theme.spacing(2)
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  marginLeft: '16px'
}));

const CardContent = styled(Stack)(() => ({
  marginTop: '20px',
  marginLeft: '20px',
  marginBottom: '20px',
  gap: '20px'
}));

const ColumnsWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    columnCount: 1
  },
  [theme.breakpoints.up('sm')]: {
    columnCount: 2
  },
  [theme.breakpoints.up('md')]: {
    columnCount: 3
  },
  [theme.breakpoints.up('lg')]: {
    columnCount: 4
  }
}));

const CardContainer = styled(Box)(({ theme }) => ({
  breakInside: 'avoid',
  marginBottom: theme.spacing(3),
  marginRight: theme.spacing(1)
}));

const ChildItem = styled(Typography)({
  color: '#414651',
  cursor: 'pointer',
  fontWeight: 400,
  fontSize: fontSizes.subtitle,
  transition: 'color 0.2s',
  '&:hover': {
    color: '#7A5AF8'
  },
  lineHeight: '1.43 !important'
});

export {
  StyledBox,
  BreadcrumbsContainer,
  StyledChildBreadcrumb,
  StyledParentBreadcrumb,
  SkeletonGridContainer,
  DashboardContainer,
  RetoolEmbedContainer,
  FlexContainer,
  DashboardFlexContainer,
  StyledCard,
  IconBox,
  CardHeader,
  CardTitle,
  CardContent,
  ColumnsWrapper,
  CardContainer,
  ChildItem,
  StyledHomeBreadcrumb
};
